import { SET_MODBUS_TEMPLATES } from './actiontypes';
import { getModbusTemplates } from '../../api/Api';

export const getModbusTemplatesAction = () => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return getModbusTemplates(jwt).then((data) =>
    dispatch({ type: SET_MODBUS_TEMPLATES, data: data.templates })
  );
};
